import * as React from 'react';
import { useSelector } from 'react-redux';

import { useButtonText } from './utils';
import { useSubmitClickHandler } from './utils/useSubmitClickHandler';
import { ValuationFiltersSubmit } from '../../components/ValuationFiltersSubmit';
import { selectCheckEstimationExists } from '../../selectors/checkEstimationExists/selectCheckEstimationExists';

interface IValuationSubmitMobileContainerProps {
  btnOnPageInViewRef?: React.Ref<HTMLButtonElement>;
}

export const ValuationSubmitMobileContainer: React.VFC<IValuationSubmitMobileContainerProps> = ({
  btnOnPageInViewRef,
}) => {
  const { isNotFound, isFetching } = useSelector(selectCheckEstimationExists);
  const submitText = useButtonText({ isSubmit: true });

  const handleClick = useSubmitClickHandler();

  return (
    <ValuationFiltersSubmit
      ref={btnOnPageInViewRef}
      onClick={handleClick}
      isLoading={isFetching}
      disabled={isNotFound}
      submitText={submitText}
    />
  );
};
